/**
 * Unified post-login navigation for every app's login screen — storage-free.
 *
 * The browser URL is preserved through the popup sign-in (and the login screen no
 * longer rewrites it), so on `USER_LOGGED_IN` we resolve the destination straight
 * from `window.location` and navigate there — no capture step, no storage.
 */
import { useEffect } from 'react';
import { useAppContext } from '../contexts/appContext';
import { AppEventType } from '../app/appEvents';
import { resolvePostLoginTarget } from './returnTo';
import { navigateTo, getRelativeLocation } from '../navigation/navigation';
export function useAuthRedirect({ appDefault }) {
    const { app } = useAppContext();
    useEffect(() => {
        const handleUserLoggedIn = () => {
            const target = resolvePostLoginTarget(appDefault);
            if (target !== getRelativeLocation()) {
                navigateTo(target);
            }
        };
        app.on(AppEventType.USER_LOGGED_IN, handleUserLoggedIn);
        return () => {
            app.off(AppEventType.USER_LOGGED_IN, handleUserLoggedIn);
        };
    }, 
    // appDefault is static per app; `app` is stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [app]);
}
